<template>
  <div>
    <b-row>
      <b-form-group class="col-6 ">
        <b-input
          v-model="busca"
          placeholder="Buscar documento"
          @input="buscar(busca)"
        />
      </b-form-group>
      <b-form-group class="col-6">
        <b-select
          :value="filtroInicial"
          class="d-inline-block"
          @input="filtrar"
        >
          <option
            :value="0"
          />
          <option
            v-for="(opcao, index) in opcoesFiltro"
            :key="index"
            :value="opcao.value"
            :class="{'titulo-opcao': opcao.title}"
            :disabled="opcao.title"
          >{{ opcao.text }}</option>
        </b-select>
      </b-form-group>
    </b-row>
  </div>
</template>

<style lang="scss">
.titulo-opcao {
  font-weight: bold;
}
</style>

<script>

export default {
  name: 'FiltroDocumento',
  components: {
  },
  props: {
    filtroInicial: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      busca: '',
      filtro: {
        filtroAtual: 0,
        busca: '',
      },
      opcoesFiltro: [
        { text: 'Filtros comuns', title: true },
        { text: 'Documentos Ativos', value: 1 },
        { text: 'Documentos Inativos', value: 2 },
        { text: 'Documentos Selecionados', value: 3 },
        { text: 'Documentos Não selecionados', value: 4 },
        { text: 'Filtros combinados', title: true },
        { text: 'Documentos Ativos - selecionados', value: 5 },
        { text: 'Documentos Ativos - não selecionados', value: 6 },
        { text: 'Documentos Inativos - selecionados', value: 7 },
        { text: 'Documentos Inativos - não selecionados', value: 8 },
      ],
    }
  },
  methods: {
    filtrar(opcao) {
      this.filtro.filtroAtual = opcao
      this.$emit('filtrado', this.filtro)
    },
    buscar(value) {
      this.filtro.busca = value
      this.$emit('filtrado', this.filtro)
    },
  },
}
</script>
